import { RefObject, useEffect } from 'react';

type TypeOutsideClick = {
  ref: RefObject<HTMLElement> | RefObject<HTMLElement>[];
  onOutsideClick: () => void;
};

export const useOutsideClick = ({ ref, onOutsideClick }: TypeOutsideClick) => {
  useEffect(() => {
    const refsArray = Array.isArray(ref) ? ref : [ref];

    const handleClickOutside = (event: MouseEvent) => {
      const isOutside = refsArray.every(
        (ref) => ref.current && !ref.current.contains(event.target as Node)
      );
      if (isOutside) {
        onOutsideClick();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onOutsideClick]);
};
